"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragLayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_dnd_1 = require("react-dnd");
const ItemView_1 = require("./ItemView");
const collect = (monitor, props) => {
    return {
        isDragging: monitor.isDragging(),
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        currentOffset: monitor.getClientOffset(),
        initialOffset: monitor.getInitialClientOffset()
    };
};
const DragLayerComponent = ({ isDragging, currentOffset, item }) => {
    if (!isDragging || !currentOffset)
        return (0, jsx_runtime_1.jsx)("div", { className: "drag-layer" }, void 0);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "drag-layer" }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
                position: 'absolute',
                left: `${currentOffset.x}px`,
                top: `${currentOffset.y}px`
            } }, { children: (0, jsx_runtime_1.jsx)(ItemView_1.ItemView, Object.assign({}, item.props, { preview: true, item: item.item }), void 0) }), void 0) }), void 0));
};
exports.DragLayer = (0, react_dnd_1.DragLayer)(collect)(DragLayerComponent);
//# sourceMappingURL=DragLayer.js.map